// src/components/home/HeroSection.jsx
import React from 'react';
import FadeInSection from '../common/FadeInSection'; // Adjust path if needed
import homeContentImg from '../../assets/garden.png'; // Adjust path if needed
import Button from '@mui/material/Button';

const HeroSection = ({ onScrollClick }) => {
 return (
    <>
      {/* --- Scoped CSS for Warm/Natural Look --- */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');

        .garden-hero-container {
          /* Background setup */
          background-image: url(${homeContentImg});
          height: 95vh;
          width: 100%;
          background-size: cover;
          background-position: center;
          background-attachment: fixed;
          
          /* Layout */
          display: flex;
          align-items: center;
          justify-content: flex-start;
          position: relative;
        }

        /* Overlay to ensure text readability */
        .hero-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.15); /* Slight dark tint */
          z-index: 1;
        }

        .hero-content-wrapper {
          position: relative;
          z-index: 2;
          width: 100%;
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 2rem;
        }

        .hero-card {
          /* Glass/Natural Effect */
          background-color: rgba(253, 251, 247, 0.92); /* Warm Cream color */
          backdrop-filter: blur(10px);
          padding: 3.5rem;
          max-width: 600px;
          border-radius: 24px; /* Soft, organic corners */
          box-shadow: 0 15px 35px rgba(48, 60, 30, 0.15); /* Soft earthen shadow */
          border: 1px solid rgba(255, 255, 255, 0.4);
          
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .hero-header {
          color: #2c4a15; /* Deep forest green */
          font-family: 'Playfair Display', serif;
          font-size: 3.5rem;
          font-weight: 700;
          line-height: 1.1;
          margin: 0;
        }

        .hero-subtitle {
          color: #5a6e46; /* Muted moss green text */
          font-family: 'Lato', sans-serif;
          font-size: 1.2rem;
          line-height: 1.6;
          margin-bottom: 1rem;
        }

        /* Responsive Adjustments */
        @media (max-width: 900px) {
          .garden-hero-container {
            justify-content: center;
            text-align: center;
          }
          
          .hero-card {
            padding: 2rem;
            margin: 0 1rem;
            align-items: center;
            background-color: rgba(253, 251, 247, 0.95);
          }

          .hero-header {
            font-size: 2.5rem;
          }
        }
      `}</style>

      <div className="garden-hero-container">
        <div className="hero-overlay"></div>
        
        <div className="hero-content-wrapper">
          <FadeInSection>
            <div className="hero-card">
              <h1 className="hero-header">Plant. Grow.<br/>Make an Impact.</h1>
              
              <p className="hero-subtitle">
                Discover the perfect plants for your space, track your environmental footprint, 
                and keep your garden thriving with our AI tools.
              </p>
              
              <div className="hero-actions">
                <Button 
                  variant="contained"
                  onClick={() => onScrollClick('homepage-section-2')}
                  sx={{
                    backgroundColor: '#556B2F',
                    color: '#fff',
                    padding: '12px 32px',
                    fontSize: '1.1rem',
                    borderRadius: '50px', // Pill shape is softer/natural
                    fontFamily: '"Lato", sans-serif',
                    textTransform: 'none',
                    fontWeight: 700,
                    boxShadow: '0 4px 14px rgba(73, 108, 28, 0.4)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      backgroundColor: '#556B2F',
                      transform: 'translateY(-2px)',
                      boxShadow: '0 6px 20px rgba(73, 108, 28, 0.6)',
                    }
                  }}
                >
                  Let's go!
                </Button>
              </div>
            </div>
          </FadeInSection>
        </div>
      </div>
    </>
  );
};

export default HeroSection;